module.exports = __webpack_public_path__ + "static/img/About_1.b6d8ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/About_1.jpg
// module id = pBxf
// module chunks = 12